export function getSizeInKB<T>(value: T) {
  const blob = new Blob([JSON.stringify(value)]) // Convert value to a Blob
  return blob.size / 1024 // Convert bytes to KB
}

export function getSizeInMB<T>(value: T) {
  return getSizeInKB(value) / 1024 // Convert KB to MB
}

// Get the size of map in KB
export function getSizeInKBMap<T>(map: Map<string, T>) {
  return Array.from(map.values()).reduce((acc, value) => acc + getSizeInKB(value), 0)
}

// Get the size of map in MB
export function getSizeInMBMap<T>(map: Map<string, T>) {
  return Array.from(map.values()).reduce((acc, value) => acc + getSizeInMB(value), 0)
}
